const checkRole = (role) => {
  // console.log(role.includes(JSON.parse(localStorage.getItem("user_auth0"))["http://role.tn/roles"][0]));
  if (
    JSON.parse(localStorage.getItem("user_auth0"))
  ) {
    if (
      role.includes(
        JSON.parse(localStorage.getItem("user_auth0"))["http://role.tn/roles"][0]
      )
    ) {
      return true;
    } else return false;
  } else return false;
};

export default checkRole;
